import './SideBar.scss'
import {DECIMAL_FORMAT, numberFormat} from "../../../../util/numbers.js";
import Counter from "../../../util/Counter.jsx";
import CircleIcon from "mdi-react/CircleIcon.js";
import {useSelector} from "react-redux";
import {getIsLiveChartActive, getLiveChartHoverValues} from "../../../../ducks/live-chart-duck.js";
import dayjs from "dayjs";

export default ({
                    assetId,
                    maxValue,
                    minValue,
                    hasData,
                    hasMovement,
                    trajectory,
                    isUsdAsset,
                    latestValue,
                    duration,
                    isLive,
                    firstValue,
                    firstLabel,
                    isNegative,
                }) => {

    const [hoverValue, hoverDatetime] = useSelector(state => getLiveChartHoverValues(state, assetId))
    const isHoverActive = useSelector(state => getIsLiveChartActive(state, assetId))

    const effectiveHoverValue = isHoverActive ? hoverValue : firstValue
    const effectiveHoverDatetime = isHoverActive ? hoverDatetime : firstLabel

    const hoverDiff = latestValue - effectiveHoverValue
    const percentDiff = hoverDiff / effectiveHoverValue

    const hoverDate = dateToString(effectiveHoverDatetime)
    const isHoverDateCurrentDate = hoverDate === dateToString()
    const isHoverDateVisible = duration > 24 * 10 || !isHoverDateCurrentDate
    const isHoverTimeVisible = duration < 24 * 10

    const rangeDelta = maxValue - minValue
    const currentDelta = maxValue - latestValue
    const rangePosition = currentDelta / rangeDelta

    let directionClass = ''
    if(hoverDiff < 0){
        directionClass = 'is-negative'
    } else if(hoverDiff > 0){
        directionClass = 'is-positive'
    }

    return (
        <div className={`side-bar`}>
            <div className='range'>
                <div className='min-value'>
                    {hasData ? numberFormat(minValue, minValue > 100_000 ? DECIMAL_FORMAT.FLEX : DECIMAL_FORMAT.FLEX_DEC_NO_TRAIL) : '•'}
                </div>
                <div className='range-gfx'>
                    {!isNegative && hasMovement && <div className={`lower-range`} style={{ width: `${(1 - rangePosition) * 100}%` }} />}
                    {isNegative && hasMovement && <div className={`higher-range`} style={{ width: `${rangePosition * 100}%` }} />}
                </div>
                <div className='max-value'>
                    {hasData ? numberFormat(maxValue, maxValue > 100_000 ? DECIMAL_FORMAT.FLEX : DECIMAL_FORMAT.FLEX_DEC_NO_TRAIL) : '•'}
                </div>
            </div>
            {hasData &&
            <div className={`latest-value in-side-bar flex-vertical-center ${trajectory} ${isHoverActive ? 'is-hover-active' : ''}`}>
                <Counter
                    prefix={isUsdAsset ? '$' : 'kr'}
                    amount={latestValue}
                    decimals={DECIMAL_FORMAT.FLEX_DEC_NO_TRAIL}
                    noColor={true}
                />
                {isLive && <CircleIcon className={`live-indicator`}/>}
            </div>
            }
            <div className={`hover-values ${isHoverActive ? 'is-active' : ''}`}>
                {/*<TimeAgo ms={dayjs().diff(hoverDatetime)} />*/}
                <div className='datetime'>
                    {isHoverTimeVisible &&
                    <span className='time'>
                        {dayjs(effectiveHoverDatetime).format('HH:mm')}
                    </span>
                    }
                    {isHoverDateVisible &&
                    <span className='date'>
                        {hoverDate}
                    </span>
                    }
                </div>
                <div className={`value flex-vertical-center`}>
                    <div className='current'>
                        {numberFormat(effectiveHoverValue, DECIMAL_FORMAT.FLEX_DEC_NO_TRAIL)}
                    </div>
                    <div>
                        <span
                            className={`prefix ${directionClass}`}>{hoverDiff < 0 ? '-' : '+'}</span>
                        {numberFormat(Math.abs(hoverDiff), DECIMAL_FORMAT.FLEX_DEC_NO_TRAIL)}
                    </div>
                </div>
                <div className={`percent-diff ${directionClass}`}>
                    {numberFormat(Math.abs(percentDiff) * 100, DECIMAL_FORMAT.FLEX_PERCENTAGE)}
                    <span className='suffix'>%</span>
                </div>
            </div>
        </div>
    )
}

const dateToString = datetime => {
    if (dayjs(datetime).startOf('date').isSame(dayjs().startOf('date'))) {
        return 'today'
    }
    if (dayjs(datetime).startOf('date').isSame(dayjs().startOf('date').subtract(1, 'day'))) {
        return 'yesterday'
    }
    if (dayjs(datetime).isAfter(dayjs().startOf('date').subtract(4, 'day'))) {
        return dayjs(datetime).format('dddd')
    }
    return dayjs(datetime).format('YYYY-MM-DD')
}